import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/Common";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import api, { formatApiError } from "@/lib/api";

export default function Profile() {
  const { user, refresh } = useAuth();
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  const [f, setF] = useState({
    first_name: user?.first_name || "", last_name: user?.last_name || "",
    phone: user?.phone || "", country: user?.country || "", preferred_language: user?.preferred_language || "de",
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async () => {
    setSaving(true);
    try { await api.patch("/profile", f); toast.success(L("Profilo aggiornato", "Profile updated", "Profil aktualisiert")); refresh(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <h2 className="font-heading text-2xl font-medium text-white">{L("Profilo", "Profile", "Profil")}</h2>
      <Card className="p-6 space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-slate-300">{L("Nome", "First name", "Vorname")}</Label><Input value={f.first_name} onChange={set("first_name")} className="mt-1.5 bg-navy border-white/10" data-testid="profile-first-name" /></div>
          <div><Label className="text-slate-300">{L("Cognome", "Last name", "Nachname")}</Label><Input value={f.last_name} onChange={set("last_name")} className="mt-1.5 bg-navy border-white/10" data-testid="profile-last-name" /></div>
        </div>
        <div><Label className="text-slate-300">{L("Email", "Email", "E-Mail")}</Label><Input value={user?.email} disabled className="mt-1.5 bg-navy/50 border-white/10 text-slate-500" /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-slate-300">{L("Telefono", "Phone", "Telefon")}</Label><Input value={f.phone} onChange={set("phone")} className="mt-1.5 bg-navy border-white/10" data-testid="profile-phone" /></div>
          <div><Label className="text-slate-300">{L("Paese", "Country", "Land")}</Label><Input value={f.country} onChange={set("country")} className="mt-1.5 bg-navy border-white/10" data-testid="profile-country" /></div>
        </div>
        <div><Label className="text-slate-300">{L("Lingua preferita", "Preferred language", "Bevorzugte Sprache")}</Label>
          <select value={f.preferred_language} onChange={set("preferred_language")} className="mt-1.5 w-full h-10 rounded-md bg-navy border border-white/10 px-3 text-sm text-white" data-testid="profile-language">
            <option value="de">Deutsch</option><option value="it">Italiano</option><option value="en">English</option>
          </select>
        </div>
        <Button onClick={save} disabled={saving} className="bg-gold text-navy hover:bg-gold-hover" data-testid="profile-save">{saving ? L("Salvataggio…", "Saving…", "Speichern…") : L("Salva modifiche", "Save changes", "Änderungen speichern")}</Button>
      </Card>
    </div>
  );
}
